import { useCallback, useState } from 'react';
import { usePostReviewLike } from '../queries/usePostReviewLike';
import type { GoodsReview } from 'shared/src/api/goodsService/getGoodsReviews';
import { bridge, isNotNil } from 'shared/src/utils';
import { useDeleteReviewLike } from '../queries/useDeleteReviewLike';
import { useLogClickReviewLike } from './useLogClickReviewLike';

export const useToggleReviewLikeStatus = (review: GoodsReview) => {
  const [isLike, setIsLike] = useState(isNotNil(review.review_like));
  const { mutateAsync: postReviewLike, isPending: loadingPostReviewLike } =
    usePostReviewLike(review.sno);
  const { mutateAsync: deleteReviewLike, isPending: loadingDeelteReviewLike } =
    useDeleteReviewLike(review.sno);

  const logClickReviewLike = useLogClickReviewLike(review);

  return {
    value: isLike,
    action: useCallback(async () => {
      if (loadingDeelteReviewLike || loadingPostReviewLike) return;
      try {
        if (isLike) {
          setIsLike(false);
          await deleteReviewLike();
          setIsLike(false);
        } else {
          setIsLike(true);
          await postReviewLike();
          setIsLike(true);
          logClickReviewLike();
        }
      } catch (ex) {
        const error = ex as Error;
        bridge.toast(error.message);

        if (error.message === '로그인이나 회원가입이 필요해요') {
          bridge.assertLogin({
            message: error.message,
            redirect: `/goods/${review.goods_sno}`,
          });
          return;
        }
      }
    }, [
      deleteReviewLike,
      isLike,
      loadingDeelteReviewLike,
      loadingPostReviewLike,
      logClickReviewLike,
      postReviewLike,
      review.goods_sno,
    ]),
  };
};
